import React from "react"
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    customstyle: {
        width: "100%",
        boxSizing:'border-box',
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontSize: 12,
        lineHeight: "20px",
        padding: "8px 12px",
        color: 'rgba(95, 96, 113, 1)',
        border: "1px solid rgba(0,0,0,0.23)", 
        outline: "none",
        resize: "vertical", 
        "&:focus": {
            borderColor: theme.palette.primary.main,
            boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
        },
        "&:disabled": {
            backgroundColor: "#f5f5f5",
            cursor: "not-allowed",
        },
    },

}));

const CustomTextAreaField = (props) => {
    const { classes, element, dataObj, key, onChange, styles, eachField, onBlurHandler, setVisible, selectedStep } = props
    const customclasses = useStyles();

    return (
        <div style={{boxSizing:'border-box'}}>
            <textarea
                className={`${customclasses.customstyle} ${classes.textArea}`}
                key={element.value || element.name}
                rows={4}
                disabled={element.readOnly}

                value={dataObj[element.value] || dataObj[element.name]}
                name={element.value || element.name}
                onChange={(e) => { onChange((element.value || element.name), e.target.value, element.type) }}
            />
        </div>
    )
}

export default CustomTextAreaField